// Sampled every 100th point from the whole dataset.
// Source: https://www.openml.org/search?type=data&sort=runs&id=42225&status=active

export const diamonds = [
  { carat: 0.23, price: 326 },
  { carat: 0.75, price: 2760 },
  { carat: 0.7, price: 2777 },
  { carat: 0.77, price: 2798 },
  { carat: 0.3, price: 554 },
  { carat: 0.71, price: 2822 },
  { carat: 0.7, price: 2838 },
  { carat: 0.7, price: 2854 },
  { carat: 1.22, price: 2862 },
  { carat: 0.73, price: 2876 },
  { carat: 0.75, price: 2898 },
  { carat: 0.71, price: 2913 },
  { carat: 0.8, price: 2935 },
  { carat: 0.72, price: 2954 },
  { carat: 0.32, price: 559 },
  { carat: 0.87, price: 2993 },
  { carat: 0.61, price: 3011 },
  { carat: 0.71, price: 3035 },
  { carat: 0.81, price: 3053 },
  { carat: 0.83, price: 3078 },
  { carat: 0.94, price: 3099 },
  { carat: 0.86, price: 3115 },
  { carat: 0.73, price: 3140 },
  { carat: 0.9, price: 3162 },
  { carat: 0.7, price: 3176 },
  { carat: 0.71, price: 3198 },
  { carat: 1.18, price: 3219 },
  { carat: 0.31, price: 562 },
  { carat: 1.04, price: 3261 },
  { carat: 0.8, price: 3283 },
  { carat: 0.7, price: 3303 },
  { carat: 0.71, price: 3321 },
  { carat: 0.7, price: 3345 },
  { carat: 0.9, price: 3368 },
  { carat: 0.3, price: 567 },
  { carat: 0.92, price: 3400 },
  { carat: 0.71, price: 3425 },
  { carat: 1, price: 3450 },
  { carat: 1, price: 3465 },
  { carat: 0.72, price: 3489 },
  { carat: 0.53, price: 3517 },
  { carat: 1.01, price: 3535 },
  { carat: 1.01, price: 3563 },
  { carat: 1.08, price: 3590 },
  { carat: 0.31, price: 571 },
  { carat: 0.9, price: 3629 },
  { carat: 1.01, price: 3658 },
  { carat: 0.9, price: 3677 },
  { carat: 0.9, price: 3697 },
  { carat: 0.9, price: 3722 },
  { carat: 0.87, price: 3742 },
  { carat: 1.01, price: 3756 },
  { carat: 0.9, price: 3780 },
  { carat: 1.01, price: 3801 },
  { carat: 1.01, price: 3818 },
  { carat: 0.93, price: 3844 },
  { carat: 1.2, price: 3871 },
  { carat: 0.3, price: 574 },
  { carat: 0.95, price: 3907 },
  { carat: 1.01, price: 3932 },
  { carat: 1.01, price: 3959 },
  { carat: 0.91, price: 3975 },
  { carat: 0.91, price: 3998 },
  { carat: 1.14, price: 4022 },
  { carat: 1.03, price: 4038 },
  { carat: 0.97, price: 4063 },
  { carat: 1, price: 4081 },
  { carat: 0.35, price: 409 },
  { carat: 0.98, price: 4116 },
  { carat: 0.9, price: 4135 },
  { carat: 1, price: 4155 },
  { carat: 1.17, price: 4167 },
  { carat: 1, price: 4189 },
  { carat: 1, price: 4202 },
  { carat: 0.33, price: 579 },
  { carat: 0.91, price: 4240 },
  { carat: 0.9, price: 4258 },
  { carat: 1.01, price: 4276 },
  { carat: 1.02, price: 4291 },
  { carat: 1, price: 4312 },
  { carat: 1.01, price: 4327 },
  { carat: 1.52, price: 4345 },
  { carat: 1, price: 4368 },
  { carat: 0.9, price: 4386 },
  { carat: 1.07, price: 4401 },
  { carat: 1.12, price: 4422 },
  { carat: 1.03, price: 4441 },
  { carat: 0.3, price: 585 },
  { carat: 0.91, price: 4474 },
  { carat: 1.07, price: 4491 },
  { carat: 0.91, price: 4512 },
  { carat: 1.01, price: 4525 },
  { carat: 1.01, price: 4549 },
  { carat: 1.15, price: 4572 },
  { carat: 1.05, price: 4586 },
  { carat: 1.13, price: 4611 },
  { carat: 0.56, price: 4632 },
  { carat: 0.32, price: 589 },
  { carat: 1.04, price: 4668 },
  { carat: 1.07, price: 4686 },
  { carat: 1, price: 4704 },
  { carat: 0.9, price: 4715 },
  { carat: 1.08, price: 4740 },
  { carat: 0.9, price: 4760 },
  { carat: 0.31, price: 593 },
  { carat: 1.02, price: 4798 },
  { carat: 1.01, price: 4825 },
  { carat: 0.72, price: 4847 },
  { carat: 1.06, price: 4862 },
  { carat: 1.02, price: 4884 },
  { carat: 1.17, price: 4914 },
  { carat: 0.82, price: 4931 },
  { carat: 1.16, price: 4958 },
  { carat: 1.54, price: 4980 },
  { carat: 1.19, price: 4998 },
  { carat: 1.05, price: 5019 },
  { carat: 1.02, price: 5044 },
  { carat: 0.34, price: 596 },
  { carat: 1.18, price: 5088 },
  { carat: 1.13, price: 5120 },
  { carat: 1.01, price: 5147 },
  { carat: 1.01, price: 5165 },
  { carat: 1.18, price: 5190 },
  { carat: 1.09, price: 5219 },
  { carat: 1.12, price: 5233 },
  { carat: 1.02, price: 5257 },
  { carat: 1, price: 5287 },
  { carat: 0.26, price: 599 },
  { carat: 0.7, price: 5338 },
  { carat: 1.06, price: 5373 },
  { carat: 1, price: 5404 },
  { carat: 0.81, price: 5423 },
  { carat: 1.08, price: 5455 },
  { carat: 1.02, price: 5493 },
  { carat: 0.32, price: 602 },
  { carat: 0.9, price: 5540 },
  { carat: 0.9, price: 5564 },
  { carat: 1.13, price: 5600 },
  { carat: 1.03, price: 5624 },
  { carat: 1, price: 5656 },
  { carat: 1.19, price: 5698 },
  { carat: 1, price: 5718 },
  { carat: 1.01, price: 5759 },
  { carat: 1.03, price: 5791 },
  { carat: 1.01, price: 5817 },
  { carat: 1.36, price: 5856 },
  { carat: 1.24, price: 5889 },
  { carat: 0.3, price: 605 },
  { carat: 1.2, price: 5955 },
  { carat: 1.02, price: 5998 },
  { carat: 1.3, price: 6042 },
  { carat: 1.42, price: 6069 },
  { carat: 1.15, price: 6106 },
  { carat: 1.29, price: 6140 },
  { carat: 1.02, price: 6169 },
  { carat: 1, price: 6209 },
  { carat: 1.01, price: 6257 },
  { carat: 0.29, price: 607 },
  { carat: 1.31, price: 6323 },
  { carat: 1.07, price: 6355 },
  { carat: 1.57, price: 6401 },
  { carat: 1, price: 6437 },
  { carat: 1.26, price: 6476 },
  { carat: 1.01, price: 6522 },
  { carat: 1.43, price: 6546 },
  { carat: 1.06, price: 6595 },
  { carat: 1.01, price: 6630 },
  { carat: 0.32, price: 421 },
  { carat: 1, price: 6701 },
  { carat: 1.5, price: 6746 },
  { carat: 1.01, price: 6787 },
  { carat: 1, price: 6818 },
  { carat: 1, price: 6871 },
  { carat: 1.01, price: 6932 },
  { carat: 1.2, price: 6969 },
  { carat: 1.04, price: 7035 },
  { carat: 1.18, price: 7087 },
  { carat: 0.32, price: 612 },
  { carat: 1.04, price: 7175 },
  { carat: 1.09, price: 7227 },
  { carat: 1.01, price: 7279 },
  { carat: 1.52, price: 7320 },
  { carat: 1.52, price: 7388 },
  { carat: 1.47, price: 7438 },
  { carat: 1.45, price: 7477 },
  { carat: 1.5, price: 7535 },
  { carat: 1.12, price: 7589 },
  { carat: 0.36, price: 619 },
  { carat: 1.06, price: 7695 },
  { carat: 1.61, price: 7754 },
  { carat: 1, price: 7822 },
  { carat: 1.52, price: 7866 },
  { carat: 1.56, price: 7950 },
  { carat: 1.01, price: 8016 },
  { carat: 1.22, price: 8062 },
  { carat: 1.01, price: 8133 },
  { carat: 1.51, price: 8223 },
  { carat: 0.37, price: 624 },
  { carat: 1.71, price: 8366 },
  { carat: 1.24, price: 8449 },
  { carat: 1.71, price: 8540 },
  { carat: 1.22, price: 8575 },
  { carat: 1.07, price: 8640 },
  { carat: 1.33, price: 8714 },
  { carat: 1.25, price: 8764 },
  { carat: 1.71, price: 8831 },
  { carat: 1.01, price: 8905 },
  { carat: 0.31, price: 625 },
  { carat: 1.2, price: 9032 },
  { carat: 1.14, price: 9116 },
  { carat: 1.1, price: 9215 },
  { carat: 1, price: 9274 },
  { carat: 1.94, price: 9344 },
  { carat: 1.51, price: 9452 },
  { carat: 1.51, price: 9513 },
  { carat: 1.53, price: 9596 },
  { carat: 1.52, price: 9700 },
  { carat: 0.31, price: 627 },
  { carat: 1.21, price: 9873 },
  { carat: 1.65, price: 9970 },
  { carat: 1.34, price: 10070 },
  { carat: 1.43, price: 10129 },
  { carat: 1.16, price: 10241 },
  { carat: 1.6, price: 10346 },
  { carat: 1.4, price: 10427 },
  { carat: 1.22, price: 10538 },
  { carat: 1.51, price: 10655 },
  { carat: 0.3, price: 630 },
  { carat: 1.52, price: 10824 },
  { carat: 1.51, price: 10939 },
  { carat: 1.01, price: 11057 },
  { carat: 2.09, price: 11119 },
  { carat: 1.27, price: 11206 },
  { carat: 1.52, price: 11333 },
  { carat: 1.13, price: 11387 },
  { carat: 2, price: 11510 },
  { carat: 1.61, price: 11627 },
  { carat: 0.36, price: 631 },
  { carat: 1.42, price: 11861 },
  { carat: 1.5, price: 12009 },
  { carat: 1.9, price: 12165 },
  { carat: 1.2, price: 12253 },
  { carat: 2, price: 12388 },
  { carat: 1.57, price: 12547 },
  { carat: 1.5, price: 12641 },
  { carat: 1.51, price: 12779 },
  { carat: 1.19, price: 12912 },
  { carat: 0.3, price: 638 },
  { carat: 2.03, price: 13182 },
  { carat: 1.58, price: 13329 },
  { carat: 1.29, price: 13530 },
  { carat: 1.5, price: 13629 },
  { carat: 1.54, price: 13794 },
  { carat: 1.58, price: 13963 },
  { carat: 1.64, price: 14107 },
  { carat: 1.51, price: 14294 },
  { carat: 2.17, price: 14452 },
  { carat: 0.34, price: 644 },
  { carat: 2.01, price: 14792 },
  { carat: 2.8, price: 15030 },
  { carat: 1.54, price: 15225 },
  { carat: 3.04, price: 15354 },
  { carat: 1.51, price: 15581 },
  { carat: 1.72, price: 15801 },
  { carat: 2.01, price: 15917 },
  { carat: 2.1, price: 16112 },
  { carat: 2.3, price: 16329 },
  { carat: 0.32, price: 645 },
  { carat: 1.52, price: 16670 },
  { carat: 2.03, price: 16900 },
  { carat: 1.56, price: 17108 },
  { carat: 2.01, price: 17244 },
  { carat: 2.01, price: 17514 },
  { carat: 2.21, price: 17784 },
  { carat: 2.08, price: 17986 },
  { carat: 2.07, price: 18198 },
  { carat: 2.03, price: 18458 },
  { carat: 0.32, price: 648 },
  { carat: 0.37, price: 649 },
  { carat: 0.4, price: 655 },
  { carat: 0.3, price: 658 },
  { carat: 0.31, price: 663 },
  { carat: 0.4, price: 666 },
  { carat: 0.32, price: 432 },
  { carat: 0.29, price: 669 },
  { carat: 0.4, price: 673 },
  { carat: 0.3, price: 675 },
  { carat: 0.3, price: 680 },
  { carat: 0.27, price: 682 },
  { carat: 0.3, price: 684 },
  { carat: 0.34, price: 686 },
  { carat: 0.34, price: 689 },
  { carat: 0.33, price: 694 },
  { carat: 0.3, price: 438 },
  { carat: 0.34, price: 698 },
  { carat: 0.32, price: 702 },
  { carat: 0.35, price: 706 },
  { carat: 0.31, price: 707 },
  { carat: 0.3, price: 709 },
  { carat: 0.31, price: 711 },
  { carat: 0.43, price: 716 },
  { carat: 0.32, price: 720 },
  { carat: 0.42, price: 722 },
  { carat: 0.3, price: 725 },
  { carat: 0.32, price: 730 },
  { carat: 0.31, price: 732 },
  { carat: 0.3, price: 447 },
  { carat: 0.4, price: 737 },
  { carat: 0.3, price: 742 },
  { carat: 0.31, price: 744 },
  { carat: 0.35, price: 747 },
  { carat: 0.3, price: 753 },
  { carat: 0.32, price: 756 },
  { carat: 0.32, price: 758 },
  { carat: 0.3, price: 764 },
  { carat: 0.34, price: 765 },
  { carat: 0.2, price: 367 },
  { carat: 0.36, price: 770 },
  { carat: 0.36, price: 773 },
  { carat: 0.3, price: 776 },
  { carat: 0.28, price: 777 },
  { carat: 0.33, price: 781 },
  { carat: 0.35, price: 788 },
  { carat: 0.32, price: 454 },
  { carat: 0.37, price: 791 },
  { carat: 0.33, price: 797 },
  { carat: 0.39, price: 802 },
  { carat: 0.31, price: 802 },
  { carat: 0.34, price: 805 },
  { carat: 0.3, price: 810 },
  { carat: 0.44, price: 813 },
  { carat: 0.38, price: 815 },
  { carat: 0.3, price: 819 },
  { carat: 0.31, price: 826 },
  { carat: 0.36, price: 828 },
  { carat: 0.32, price: 828 },
  { carat: 0.31, price: 462 },
  { carat: 0.3, price: 838 },
  { carat: 0.4, price: 842 },
  { carat: 0.3, price: 844 },
  { carat: 0.42, price: 847 },
  { carat: 0.43, price: 852 },
  { carat: 0.33, price: 854 },
  { carat: 0.3, price: 858 },
  { carat: 0.34, price: 863 },
  { carat: 0.42, price: 867 },
  { carat: 0.27, price: 470 },
  { carat: 0.46, price: 874 },
  { carat: 0.36, price: 877 },
  { carat: 0.33, price: 880 },
  { carat: 0.43, price: 882 },
  { carat: 0.3, price: 886 },
  { carat: 0.46, price: 891 },
  { carat: 0.3, price: 473 },
  { carat: 0.41, price: 900 },
  { carat: 0.41, price: 904 },
  { carat: 0.31, price: 907 },
  { carat: 0.3, price: 911 },
  { carat: 0.31, price: 914 },
  { carat: 0.32, price: 918 },
  { carat: 0.42, price: 921 },
  { carat: 0.4, price: 926 },
  { carat: 0.35, price: 931 },
  { carat: 0.32, price: 936 },
  { carat: 0.31, price: 942 },
  { carat: 0.41, price: 945 },
  { carat: 0.32, price: 477 },
  { carat: 0.35, price: 952 },
  { carat: 0.3, price: 956 },
  { carat: 0.41, price: 960 },
  { carat: 0.5, price: 965 },
  { carat: 0.41, price: 969 },
  { carat: 0.33, price: 974 },
  { carat: 0.54, price: 978 },
  { carat: 0.46, price: 983 },
  { carat: 0.5, price: 984 },
  { carat: 0.23, price: 485 },
  { carat: 0.5, price: 994 },
  { carat: 0.51, price: 1000 },
  { carat: 0.41, price: 1007 },
  { carat: 0.43, price: 1008 },
  { carat: 0.36, price: 1013 },
  { carat: 0.44, price: 1016 },
  { carat: 0.37, price: 487 },
  { carat: 0.35, price: 1024 },
  { carat: 0.5, price: 1031 },
  { carat: 0.37, price: 1038 },
  { carat: 0.37, price: 1041 },
  { carat: 0.31, price: 1046 },
  { carat: 0.33, price: 1052 },
  { carat: 0.41, price: 1055 },
  { carat: 0.41, price: 1061 },
  { carat: 0.41, price: 1064 },
  { carat: 0.38, price: 1069 },
  { carat: 0.41, price: 1076 },
  { carat: 0.33, price: 1079 },
  { carat: 0.3, price: 491 },
  { carat: 0.4, price: 1088 },
  { carat: 0.38, price: 1096 },
  { carat: 0.42, price: 1103 },
  { carat: 0.41, price: 1107 },
  { carat: 0.33, price: 1114 },
  { carat: 0.39, price: 1121 },
  { carat: 0.4, price: 1125 },
  { carat: 0.34, price: 1133 },
  { carat: 0.37, price: 1142 },
  { carat: 0.32, price: 497 },
  { carat: 0.4, price: 1158 },
  { carat: 0.43, price: 1169 },
  { carat: 0.45, price: 1178 },
  { carat: 0.39, price: 1183 },
  { carat: 0.5, price: 1193 },
  { carat: 0.32, price: 1204 },
  { carat: 0.38, price: 1211 },
  { carat: 0.52, price: 1223 },
  { carat: 0.62, price: 1234 },
  { carat: 0.24, price: 393 },
  { carat: 0.42, price: 1241 },
  { carat: 0.5, price: 1250 },
  { carat: 0.55, price: 1260 },
  { carat: 0.59, price: 1265 },
  { carat: 0.51, price: 1274 },
  { carat: 0.54, price: 1287 },
  { carat: 0.51, price: 1294 },
  { carat: 0.43, price: 1308 },
  { carat: 0.57, price: 1320 },
  { carat: 0.32, price: 505 },
  { carat: 0.52, price: 1338 },
  { carat: 0.53, price: 1351 },
  { carat: 0.54, price: 1361 },
  { carat: 0.5, price: 1368 },
  { carat: 0.53, price: 1383 },
  { carat: 0.53, price: 1395 },
  { carat: 0.58, price: 1401 },
  { carat: 0.59, price: 1412 },
  { carat: 0.54, price: 1422 },
  { carat: 0.29, price: 507 },
  { carat: 0.5, price: 1436 },
  { carat: 0.58, price: 1442 },
  { carat: 0.29, price: 511 },
  { carat: 0.3, price: 394 },
  { carat: 0.7, price: 1556 },
  { carat: 0.51, price: 1569 },
  { carat: 0.5, price: 1577 },
  { carat: 0.43, price: 1584 },
  { carat: 0.6, price: 1599 },
  { carat: 0.53, price: 1607 },
  { carat: 0.5, price: 1613 },
  { carat: 0.5, price: 1624 },
  { carat: 0.5, price: 1629 },
  { carat: 0.57, price: 1637 },
  { carat: 0.5, price: 1648 },
  { carat: 0.51, price: 1656 },
  { carat: 0.31, price: 523 },
  { carat: 0.55, price: 1668 },
  { carat: 0.54, price: 1680 },
  { carat: 0.5, price: 1690 },
  { carat: 0.57, price: 1698 },
  { carat: 0.5, price: 1710 },
  { carat: 0.52, price: 1720 },
  { carat: 0.55, price: 1725 },
  { carat: 0.55, price: 1741 },
  { carat: 0.68, price: 1749 },
  { carat: 0.3, price: 526 },
  { carat: 0.5, price: 1766 },
  { carat: 0.54, price: 1778 },
  { carat: 0.54, price: 1786 },
  { carat: 0.55, price: 1792 },
  { carat: 0.7, price: 1806 },
  { carat: 0.56, price: 1814 },
  { carat: 0.53, price: 1818 },
  { carat: 0.51, price: 1826 },
  { carat: 0.5, price: 1838 },
  { carat: 0.3, price: 394 },
  { carat: 0.53, price: 1848 },
  { carat: 0.7, price: 1865 },
  { carat: 0.52, price: 1878 },
  { carat: 0.71, price: 1883 },
  { carat: 0.71, price: 1901 },
  { carat: 0.76, price: 1914 },
  { carat: 0.52, price: 1919 },
  { carat: 0.7, price: 1935 },
  { carat: 0.55, price: 1948 },
  { carat: 0.31, price: 533 },
  { carat: 0.71, price: 1968 },
  { carat: 0.71, price: 1981 },
  { carat: 0.6, price: 1996 },
  { carat: 0.54, price: 2009 },
  { carat: 0.7, price: 2025 },
  { carat: 0.59, price: 2040 },
  { carat: 0.73, price: 2050 },
  { carat: 0.52, price: 2064 },
  { carat: 0.72, price: 2079 },
  { carat: 0.31, price: 539 },
  { carat: 0.5, price: 2105 },
  { carat: 0.55, price: 2119 },
  { carat: 0.52, price: 2137 },
  { carat: 0.7, price: 2147 },
  { carat: 0.7, price: 2164 },
  { carat: 0.62, price: 2178 },
  { carat: 0.57, price: 2193 },
  { carat: 0.71, price: 2207 },
  { carat: 0.9, price: 2226 },
  { carat: 0.27, price: 544 },
  { carat: 0.71, price: 2255 },
  { carat: 0.7, price: 2270 },
  { carat: 0.82, price: 2283 },
  { carat: 0.56, price: 2290 },
  { carat: 0.61, price: 2306 },
  { carat: 0.56, price: 2318 },
  { carat: 0.73, price: 2326 },
  { carat: 0.56, price: 2336 },
  { carat: 0.7, price: 2351 },
  { carat: 0.31, price: 544 },
  { carat: 0.74, price: 2369 },
  { carat: 0.77, price: 2382 },
  { carat: 0.7, price: 2394 },
  { carat: 0.7, price: 2400 },
  { carat: 0.7, price: 2415 },
  { carat: 0.7, price: 2433 },
  { carat: 0.81, price: 2444 },
  { carat: 0.55, price: 2459 },
  { carat: 0.54, price: 2479 },
  { carat: 0.32, price: 548 },
  { carat: 0.56, price: 2510 },
  { carat: 0.71, price: 2525 },
  { carat: 0.71, price: 2543 },
  { carat: 0.59, price: 2553 },
  { carat: 0.83, price: 2570 },
  { carat: 0.73, price: 2586 },
  { carat: 0.7, price: 2596 },
  { carat: 0.7, price: 2614 },
  { carat: 0.71, price: 2633 },
  { carat: 0.3, price: 552 },
  { carat: 0.77, price: 2667 },
  { carat: 0.71, price: 2685 },
  { carat: 0.91, price: 2700 },
  { carat: 0.7, price: 2717 },
  { carat: 0.9, price: 2732 },
  { carat: 0.73, price: 2752 },
];
